import React from 'react';
import PropTypes from 'prop-types';
import { getNodes } from '../utils/contentful';
import Page from '../components/Page';

PageTemplate.propTypes = {
  data: PropTypes.shape({
    page: PropTypes.shape({
      title: PropTypes.string.isRequired,
      content: PropTypes.shape({
        childMarkdownRemark: PropTypes.shape({
          html: PropTypes.string,
        }).isRequired,
      }).isRequired,
      image: PropTypes.shape({
        file: PropTypes.shape({
          url: PropTypes.string.isRequired,
        }).isRequired,
      }),
    }).isRequired,
    pages: PropTypes.shape({}).isRequired,
  }).isRequired,
  location: PropTypes.shape({}).isRequired,
};

export default function PageTemplate({ data: { page: { title, content, image }, pages }, location }) {
  return (
    <Page
      title={title}
      imageUrl={image && image.file.url}
      pages={getNodes(pages)}
      location={location}
    >
      <article dangerouslySetInnerHTML={{ __html: content.childMarkdownRemark.html }} />
    </Page>
  );
}

export const pageQuery = graphql`
  query PageQuery($slug: String!) {
    page: contentfulPage(slug: { eq: $slug }) {
      title
      content {
        childMarkdownRemark {
          html
        }
      }
      image {
        file {
          url
        }
      }
    }
    pages: allContentfulPage(limit: 1000) {
      edges {
        node {
          id
          slug
          title
          subpages {
            id
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/Page.js